import moment from 'moment';

// utils
import { isChecked } from './dynamicFilters';

export const filteredBookingItems = (bookingItems, filters) => {
  return bookingItems.filter(bookingItem => {
    const filterResults = [];

    if (filters.startDate) {
      filterResults.push(
        moment(filters.startDate).isSameOrBefore(bookingItem.startTime, 'day')
      );
    }

    if (filters.endDate) {
      filterResults.push(
        moment(filters.endDate).isSameOrAfter(bookingItem.endTime, 'day')
      );
    }

    if (filters.statuses.filter(isChecked).length > 0) {
      filterResults.push(
        filters.statuses.filter(isChecked).some(status => {
          return status.id === bookingItem.state;
        })
      );
    }

    if (filters.spaces.filter(isChecked).length > 0) {
      filterResults.push(
        filters.spaces.filter(isChecked).some(space => {
          return space.id === bookingItem.space.id;
        })
      );
    }

    return !filterResults.includes(false);
  });
};

export const filteredKeyFacets = <F extends { isKey: boolean }[]>(
  facets: F
): F => facets.filter(facet => facet.isKey);

export const filteredVenueDiscounts = (discounts, venue) => {
  const roomTypeIds = [
    ...new Set(venue.spaces?.map(space => space.categoryIds).flat()),
  ];

  const roomIds = [...new Set(venue.spaces?.map(space => space.id).flat())];

  return discounts
    .filter(discount => {
      if (discount.spaceIds.length === 0 && discount.roomTypeIds.length === 0) {
        return discount.venueIds.includes(venue.id);
      }

      return (
        ((discount.venueIds.length === 0 ||
          discount.venueIds.includes(venue.id)) &&
          roomTypeIds.some(roomTypeId =>
            discount.roomTypeIds.includes(roomTypeId)
          )) ||
        roomIds.some(spaceId => discount.spaceIds.includes(spaceId))
      );
    })
    .sort((a, b) => b.amount > a.amount);
};

export const filteredSpaceDiscounts = (discounts, venue, space) =>
  discounts
    .filter(
      ({ venueIds = [], spaceIds = [], roomTypeIds = [] }) =>
        (venueIds.includes(venue.id) &&
          spaceIds.length === 0 &&
          roomTypeIds.length === 0) ||
        spaceIds?.includes(space.id) ||
        (venueIds.includes(venue.id) &&
          roomTypeIds.includes(space.categoryIds[0]))
    )
    .sort((a, b) => b.amount > a.amount);
